<template>
  <div class="serviceBox">
    <websiteTop :categoryIndex1="3" />
    <div class="serviceTop">
      <div class="flex">
        <p>技术服务/服务保障</p>
        <img src="@/assets/image/服务.png" />
      </div>
    </div>
    <div class="serviceCenter">
      <div class="title align-center">
        <p class="p1">服务</p>
        <p class="p2">MAIN PRODUCTS</p>
      </div>
      <div class="servicecontent">
        <div class="content space-between">
          <div class="div1">
            <div class="aa align-center">
              <img src="@/assets/image/服务图标/伴随服务.png" />
              <p>伴随服务</p>
            </div>
            <p class="p1">
              QQ、微信日常伴随、5X8实时伴随、365天技术、QA执勤
              周报工作制度、专属项目组跟踪服务、项目经理1对1伴随
            </p>
          </div>
          <div class="div1">
            <div class="aa align-center">
              <img src="@/assets/image/服务图标/技术响应.png" />
              <p>技术响应</p>
            </div>
            <p class="p1">
              ７X24小时技术响应、重大故障30分钟响应、重大故障现场响应、标准化平台巡检服务、项目组技术响应考评保障
            </p>
          </div>
          <div class="div1">
            <div class="aa align-center">
              <img src="@/assets/image/服务图标/施工保障.png" />
              <p>施工保障</p>
            </div>
            <p class="p1">
              专业团队调研并实施、研发团队驻场、现场咨询、汇报、培训定期现场回访
            </p>
          </div>
        </div>
        <div class="content space-between">
          <div class="div1">
            <div class="aa align-center">
              <img src="@/assets/image/服务图标/源代码开放.png" />
              <p>源代码开放</p>
            </div>
            <p class="p1">
              源代码定向开放(需签保密协议)、 共享开发成果、全套研发文档交付
              辅导二次开发、定期举办二次开发培训会
            </p>
          </div>
          <div class="div1">
            <div class="aa align-center">
              <img src="@/assets/image/服务图标/运维服务.png" />
              <p>运维服务</p>
            </div>
            <p class="p1">
              服务器巡检、运维托管、官方云计算专家保障、远程技术保障、异常情况自动提醒服务
            </p>
          </div>
          <div class="div1">
            <div class="aa align-center">
              <img src="@/assets/image/服务图标/高级服务.png" />
              <p>高级服务</p>
            </div>
            <p class="p1">
              系统对接咨询支持、区域融合现场支持、智慧城市合作支持、会议支持、平台整合支持
            </p>
          </div>
        </div>
      </div>
    </div>
    <websiteBottom />
  </div>
</template>
<script>
export default {
  created() {
    window.document.title = "服务-湖南鼎太";
  },
};
</script>
<style lang="scss" scoped>
.serviceBox {
  .serviceTop {
    background-color: #3860f4;
    padding-top: 30px;
    div {
      width: 1200px;
      margin: 0 auto;
      justify-content: space-between;
      padding-top: 20px;
    }
    p {
      width: 405px;
      font-size: 48px;
      font-family: PangMenZhengDao;
      font-weight: 400;
      font-style: italic;
      color: #ffffff;
      line-height: 50px;
      padding-top: 60px;
    }
  }
  .serviceCenter {
    padding-top: 130px;
    background-color: #f9faff;
    .title {
      width: 1200px;
      margin: 0 auto;
      .p1 {
        width: 53px;
        font-size: 26px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #374567;
        line-height: 30px;
      }
      .p2 {
        font-size: 22px;
        font-family: Helvetica-Condensed-Light-Li;
        font-weight: bold;
        color: #000;
        line-height: 25px;
        margin-left: 25px;
      }
    }
    .servicecontent {
      width: 1200px;
      margin: 0 auto;
      padding-top: 41px;
      padding-bottom: 101px;
      .content {
        padding-top: 31px;
        .div1 {
          width: 380px;
          background-color: #fff;
          .aa {
            padding-top: 31px;
            padding-left: 61.5px;
            p {
              display: inline-block;
              font-size: 18px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #374567;
              margin-left: 13px;
            }
          }
          .p1 {
            padding-top: 26px;
            padding-bottom: 40px;
            margin: 0 auto;
            width: 257px;
            font-size: 17px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #000;
            line-height: 32px;
          }
        }
      }
    }
  }
}
</style>
